// ACC
const ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM = 'ACCPermanentInjuryToothDamageCovCovPIDegree';
const ACC_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM = 'ACCPermanentInjuryToothDamageCovSumInsured';
const ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT = 5;
const ACC_INJURY_TOOTH_DAMAGE_EIGHT_PERCENT = 8;
const CHILD_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM = 'ACCChildPermInjAccCovSumInsured';
const ACC_DEATH_COVERAGE_TERM = 'ACCDeathCovSumInsured';

// PRH
const PRH_PRIVATE_CONTENT_SUM_INSURED_TERM = 'PRHPrivateContentCovSumInsuredNew';
const PRH_PRIVATE_CONTENT_MANUAL_SUM = 'PRHPrivateContentCovManualSum';
const PRH_FIRE_DEDUCTIBLE = 'PRHFireCovDeductible';
const PRH_STORM_DEDUCTIBLE = 'PRHStormCovDeductible';
const PRH_LIABILITY_DEDUCTIBLE_DISPLAY_NAME = 'Husejeransvar:';

// MVP
const MVP_COMPREHENSIVE_AUDIO_TEL = 'MVPComprehensiveAudioTelcoEquipent';

// UVP
const UVP_CONTENT_SUM = 'UVPContentCovSum';

export {
    ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM,
    ACC_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM,
    ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT,
    ACC_INJURY_TOOTH_DAMAGE_EIGHT_PERCENT,
    CHILD_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM,
    ACC_DEATH_COVERAGE_TERM,
    PRH_LIABILITY_DEDUCTIBLE_DISPLAY_NAME,
    PRH_PRIVATE_CONTENT_SUM_INSURED_TERM,
    PRH_PRIVATE_CONTENT_MANUAL_SUM,
    PRH_FIRE_DEDUCTIBLE,
    PRH_STORM_DEDUCTIBLE,
    MVP_COMPREHENSIVE_AUDIO_TEL,
    UVP_CONTENT_SUM
};
